import "../../../assets/scss/google-cloud-download-modal-style.scss";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, message, Modal, Skeleton, Spin } from "antd";
import {
  BranchesOutlined,
  DesktopOutlined,
  LoadingOutlined,
  RobotOutlined,
} from "@ant-design/icons";

import { downloadDriveToDocker } from "../../server/GoogleDrive";
import { getInstances } from "../../server/Instances";
import { useAppSelector } from "../../store/hooks";
import { InstanceCardInterface } from "../../utility/interface/instance-card";

const CloudDownloadMdoal = (props: any) => {
  const { t } = useTranslation();
  const { file_id, modalState, onCancelfn, user_id } = props;
  const userState = useAppSelector((state: any) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [downloading, setDownloading] = useState<boolean>(false);
  const [instancesList, setInstancesList] = useState<InstanceCardInterface[]>(
    []
  );

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const fetchInstanceList = async () => {
    try {
      const response = await getInstances();
      const data = await response.data;
      setLoading(false);
      if (data.instances !== null) {
        setInstancesList(data.instances.reverse());
      }
    } catch {
      setInstancesList([]);
    }
  };

  const downloadDriveToDockerFn = (instance_id: string, host_id: string) => {
    downloadDriveToDocker({
      file_id: file_id,
      instance_id: instance_id,
      destination_path: `./`,
      host_id: host_id,
      user_id: user_id,
    })
      .then((res: any) => {
        if (res.data.code === 0) {
          downloadFileSuccess();
        } else {
          downloadFileFailed();
        }
      })
      .catch((err) => {
        downloadFileFailed();
      });
  };

  const downloadFileSuccess = () => {
    messageApi.success(t("Download Success!"), 2.5).then(() => {
      setDownloading(false);
      onCancelfn();
    });
  };

  const downloadFileFailed = () => {
    messageApi.error(t("Download Failed!"), 2.5).then(() => {
      setDownloading(false);
      onCancelfn();
    });
  };
  const stateError = () => {
    messageApi.error({
      content: t("Please connect to Google Drive!"),
    });
  };

  useEffect(() => {
    if (userState.user_id) {
      setLoading(true);
      fetchInstanceList();
    }
  }, [useState]);

  return (
    <>
      {contextHolder}
      {downloading == false && (
        <Modal
          open={modalState}
          onCancel={() => onCancelfn()}
          width={"auto"}
          className="google-cloud-download-modal"
          footer={null}
          closable={!loading}
          centered
        >
          {instancesList.length === 0 && loading == false && (
            <div className="no-instances">
              <p>{t("No Machines Yet")}</p>
              <Button onClick={() => navigate("/")}>{t("Go to Rental")}</Button>
            </div>
          )}
          {loading === true ? (
            <div
              style={{
                display: "flex",
                alignItems: "middle",
                justifyContent: "center",
              }}
            >
              <Spin
                indicator={<LoadingOutlined spin style={{ fontSize: 72 }} />}
              />
            </div>
          ) : (
            <div className="file-cloud-download">
              {instancesList.map((item: any, index: any) => {
                return (
                  <div
                    key={index}
                    className="instance-item"
                    onClick={() => {
                      setLoading(true);
                      setDownloading(true);
                      messageApi.loading({
                        content: t("Downloading..."),
                        duration: 0,
                      });
                      downloadDriveToDockerFn(item.instance_id, item.host_id);
                    }}
                  >
                    <li>
                      <DesktopOutlined /> ID: {item.instance_id}
                    </li>
                    <li>
                      <RobotOutlined /> {t("Machine")}: {item.product_name}
                    </li>
                    <li>
                      <BranchesOutlined /> {t("GPU Count")}:{" "}
                      {item.gpu_available} GPU
                    </li>
                    <strong>{t("Download to This Instance")}</strong>
                  </div>
                );
              })}
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default CloudDownloadMdoal;
